export { FileLineageTree as default } from "./FileLineageTree";
